import * as actionTypes from "../consts/actionTypes";

const initialValues = {
  afilliatedAppointments: {
    NumeroPersona: 0,
    SolicitudTurnos: "",
    Count: 0,
    Skip: 0,
  },
  all: [],
  next: [],
  appointmentNextFullData: [],
  appointmentRecordFullData: [],
  appointmentFavoriteFullData: [],
  appointmentQuestionFullData: [],
  record: [],
  favorite: [],
  questionF: [],
  filtro: [],
  fullDataFiltro: [],
  groupFamilyTurn: [],
  nextAvailableAppointments: [],
  appointments: [],
  modelAppointment: [],
  nextAvailableAppointmentsDoctor: [],
  postAppointment: [],
  modelModifyAppointment: [],
  isLoading: false,
  msgError: '',
  specialtiesList: [],
  doctorsList: [],
  freeDoctorAppointmentsList: [],
  medicalAgenda: [],
  evolutions: [],
  evolutionsByDetail: [],
  postEvolution: [],
  laboratory: [],
  vitalSigns: [],
  anthropometry: [],
  postVitalSigns: [],
  postLaboratory: [],
  postAnthropometry: [],
  /**crear los objetos que vienen del servicio */
};

export default function appointmentsReducer(state = initialValues, action) {
  const ACTIONS = {
    [actionTypes.FAILURE_GET_AFILLIATED_APPOINTMENTS]: responseToReturn(),
    [actionTypes.FAILURE_GET_AFILLIATED_APPOINTMENTS_NEXT]: responseToReturn(),
    [actionTypes.FAILURE_GET_AFILLIATED_APPOINTMENTS_RECORD]: responseToReturn(),
    [actionTypes.FAILURE_GET_APPOINTMENTS_FAVORITE]: responseToReturn(),
    [actionTypes.FAILURE_GET_DATA_GROUP_FAMILY]: responseToReturn(),
    [actionTypes.FAILURE_GET_DATA_FILTER_APPOINTMENT]: responseToReturn(),
    [actionTypes.FAILURE_GET_APPOINTMENTS_CANCELED]: responseToReturn(),
    [actionTypes.FAILURE_GET_APPOINTMENTS_AB]: responseToReturn(),
    [actionTypes.FAILURE_ANSWER_QUESTION]: responseToReturn(),
    [actionTypes.FAILURE_GET_NEXT_AVAILABLE_APPOINTMENTS]: responseToReturn(),
    [actionTypes.FAILURE_GET_NEXT_AVAILABLE_APPOINTMENTS_DOCTOR]: responseToReturn(),
    [actionTypes.FAILURE_GET_APPOINTMENTS_CONFIRMED]: responseToReturn(),
    [actionTypes.FAILURE_GET_FULL_GROUP_FAMILY_APPOINTMENT]: responseToReturn(),
    [actionTypes.CLEAR_APPOINTMENT_MSG_ERROR]: clearState('msgError'),
    [actionTypes.FAILURE_GET_SPECIALTIES_LIST]: responseToReturn(),
    [actionTypes.FAILURE_GET_DOCTORS_LIST]: responseToReturn(),
    [actionTypes.FAILURE_GET_FREE_DOCTOR_APPOINTMENTS_LIST]: responseToReturn(),
    [actionTypes.FAILURE_GET_MEDICAL_AGENDA]: responseToReturn(),
    [actionTypes.FAILURE_GET_SPECIALTY_LIST]: responseToReturn(),
    [actionTypes.RESET_APPOINTMENT_ERROR]: clearErrorMessageAppointmen(),
    [actionTypes.FAILURE_GET_EVOLUTIONS_DETAIL]: responseToReturn(),
    [actionTypes.FAILURE_GET_LABORATORY_DETAIL]: responseToReturn(),
    [actionTypes.FAILURE_GET_VITAL_SIGNS_DETAIL]: responseToReturn(),
    [actionTypes.FAILURE_GET_EVOLUTIONS_BY_DETAIL]: responseToReturn(),
    [actionTypes.SUCCESS_POST_EVOLUTIONS]: responseToReturn('postEvolution'),
    [actionTypes.FAILURE_POST_EVOLUTIONS]: responseToReturn(),
    [actionTypes.FAILURE_GET_ANTHROPOMETRY_DETAIL]: responseToReturn(),
    [actionTypes.SUCCESS_POST_VITAL_SIGNS]: responseToReturn('postVitalSigns'),
    [actionTypes.FAILURE_POST_VITAL_SIGNS]: responseToReturn(),
    [actionTypes.SUCCESS_POST_LABORATORY]: responseToReturn('postLaboratory'),
    [actionTypes.FAILURE_POST_LABORATORY]: responseToReturn(),
    [actionTypes.SUCCESS_POST_ANTHROPOMETRY]: responseToReturn('postAnthropometry'),
    [actionTypes.FAILURE_POST_ANTHROPOMETRY]: responseToReturn(),
  };

  function responseToReturn() {
    let res = { ...state };
    if (action.message) {
        res = { ...state, msgError: action.message, isLoading: false };
    }
    return res;
  }

  function clearErrorMessageAppointmen() {
        return { ...state, msgError: '' };
    }

  function clearState(type) {
    if (type) {
      return { ...state, [type]: initialValues[type] };
    } else {
      return { ...initialValues }
    }
  }

  if (ACTIONS[action.type] !== undefined) {
    return ACTIONS[action.type];
  }

  switch (action.type) {
    case actionTypes.GET_NEXT_AVAILABLE_APPOINTMENTS:
      return { ...state, nextAvailableAppointments: [], isLoading: true };
    case actionTypes.GET_NEXT_AVAILABLE_APPOINTMENTS_DOCTOR:
      return { ...state, nextAvailableAppointments: [], isLoading: true };
    case actionTypes.GET_AFILLIATED_APPOINTMENTS:
      return { ...state, appointments: [], isLoading: true };
    case actionTypes.GET_FREE_DOCTOR_APPOINTMENTS_LIST:
      return { ...state, freeDoctorAppointmentsList: [], isLoading: true };
    case actionTypes.GET_MEDICAL_AGENDA:
      return { ...state, medicalAgenda: [], isLoading: true };
    case actionTypes.SUCCESS_GET_AFILLIATED_APPOINTMENTS:
      if (action.response) {
        return { ...state, appointments: action.response.data.data.turnos, msgError:'', isLoading: false };
      } else {
        return { ...state };
      }
    case actionTypes.SUCCESS_GET_AFILLIATED_APPOINTMENTS_NEXT:
      if (action.response) {
        return { ...state, next: action.response.data.data.turnos, appointmentNextFullData: action.response.data.data, msgError:'' };
      } else {
        return { ...state };
      }

    case actionTypes.SUCCESS_GET_AFILLIATED_APPOINTMENTS_RECORD:
      if (action.response) {
        return { ...state, record: action.response.data.data.turnos, appointmentRecordFullData: action.response.data.data, msgError:'' };
      } else {
        return { ...state };
      }
    case actionTypes.SUCCES_GET_APPOINTMENTS_FAVORITE:
      if (action.response) {
        return { ...state, favorite: action.response.data.data.favoritos, appointmentFavoriteFullData: action.response.data.data, msgError:'' };
      } else {
        return { ...state };
      }
    case actionTypes.SUCCES_GET_DATA_GROUP_FAMILY:
      if (action.response) {
        return {
          ...state,
          groupFamilyTurn: action.response.data.data.items,
          msgError:''
        };
      } else {
        return { ...state };
      }
    case actionTypes.SUCCES_GET_DATA_FILTER_APPOINTMENT:
      if (action.response) {
        return {
          ...state,
          filtro: action.response.data.data.afiliados,
          fullDataFiltro: action.response.data.data,
          msgError:''
        };
      } else {
        return { ...state };
      }
    case actionTypes.SUCCES_GET_APPOINTMENTS_CANCELED:
      if (action.response) {
        return { ...state, afilliatedAppointments: action.response.data.data, msgError:'' };
      } else {
        return { ...state };
      }
    case actionTypes.SUCCES_GET_APPOINTMENTS_AB:
      if (action.response) {
        return { ...state, afilliatedAppointments: action.response.data.data, msgError:'' };
      } else {
        return { ...state };
      }
    case actionTypes.SUCCES_ANSWER_QUESTION:
      if (action.response) {
        return { ...state, questionF: action.response.data.answerQuestion, appointmentQuestionFullData: action.response.data, msgError:'' };
      } else {
        return { ...state };
      }
    case actionTypes.SUCCESS_GET_NEXT_AVAILABLE_APPOINTMENTS:
      if (action.response) {
        return { ...state, nextAvailableAppointments: action.response.data, isLoading: false, msgError:'' };
      }
      else {
        return { ...state, isLoading: false };
      }
    case actionTypes.SUCCESS_GET_NEXT_AVAILABLE_APPOINTMENTS_DOCTOR:
      if (action.response) {
        const messages = action.response.data?.mensajes;
        return { ...state, nextAvailableAppointmentsDoctor: action.response.data, isLoading: false, msgError: messages };
      }
      else {
        return { ...state };
      }
    case actionTypes.SUCCESS_GET_MEDICAL_AGENDA:
      if (action.response) {
        return { ...state, medicalAgenda: action.response.data, isLoading: false, msgError:'' };
      }
      case actionTypes.SUCCESS_GET_EVOLUTIONS_DETAIL:
      if (action.response) {
        return { ...state, evolutions: action.response.data.data.detalleEvolucion, isLoading: false, msgError:'' };
      }
      case actionTypes.SUCCESS_GET_LABORATORY_DETAIL:
      if (action.response) {
        return { ...state, laboratory: action.response.data.data.detalleLaboratorio, isLoading: false, msgError:'' };
      }
      case actionTypes.SUCCESS_GET_VITAL_SIGNS_DETAIL:
      if (action.response) {
        return { ...state, vitalSigns: action.response.data.data.detalleSignosVitales, isLoading: false, msgError:'' };
      }
      case actionTypes.SUCCESS_GET_ANTHROPOMETRY_DETAIL:
      if (action.response) {
        return { ...state, anthropometry: action.response.data.data.detalleAtropometrias, isLoading: false, msgError:'' };
      }
      case actionTypes.SUCCESS_GET_EVOLUTIONS_BY_DETAIL:
      if (action.response) {
        return { ...state, evolutionsByDetail: action.response.data.data.pacienteEvolucion, isLoading: false, msgError:'' };
      }
      else {
        return { ...state };
      }
    case actionTypes.SET_MODEL_TO_SAVE_APPOINTMENT:
      return { ...state, modelAppointment: action.payload };
    case actionTypes.GET_MODEL_TO_SAVE_APPOINTMENT:
      return { ...state };
    case actionTypes.SUCCESS_GET_APPOINTMENTS_CONFIRMED:
      if (action.response) {
        return { ...state, postAppointment: action.response.data, msgError:'' };
      }
      else {
        return { ...state };
      }
    case actionTypes.SUCCESS_GET_FULL_GROUP_FAMILY_APPOINTMENT:
      if (action.response) {
        return { ...state, fullGroupFamily: action.response.data.data, msgError:'' };
      }
      else {
        return { ...state };
      }

    case actionTypes.SUCCESS_GET_SPECIALTIES_LIST:
      if (action.response) {
        return { ...state, specialtiesList: action.response.data.data, msgError: '' };
      } else {
        return { ...state };
      }

    case actionTypes.SUCCESS_GET_DOCTORS_LIST:
      if (action.response) {
        return { ...state, doctorsList: action.response.data.data, msgError: '' };
      } else {
        return { ...state };
      }

    case actionTypes.SUCCESS_GET_FREE_DOCTOR_APPOINTMENTS_LIST:
      if (action.response) {
        return { ...state, freeDoctorAppointmentsList: action.response.data.data, msgError: '', isLoading: false };
      } else {
        return { ...state };
      }

    case actionTypes.CLEAR_MODEL_APPOINTMENT:
      return { ...state, modelAppointment: [] };
    case actionTypes.CLEAR_AFFILLIATE:
      return {
        ...state, afilliatedAppointments: {
          NumeroPersona: 0,
          SolicitudTurnos: "",
          Count: 0,
          Skip: 0,
        },
      };
    case actionTypes.SET_MODIFY_APPOINTMENT:
      return { ...state, modelModifyAppointment: action.payload };

    default:
      return { ...state };
  }
}
